import React from 'react';

const NoDataAvailableSVG: React.FC<React.SVGProps<SVGSVGElement>> = ( { ...props } ) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      {...props}
    >
      {/* Document principal */}
      <path
        d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 2v6h6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Lignes de contenu dans le document */}
      <line x1="8" y1="13" x2="16" y2="13" strokeLinecap="round" />
      <line x1="8" y1="17" x2="14" y2="17" strokeLinecap="round" />

      {/* Document en arrière-plan */}
      <path
        d="M16 4H8a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V10l-4-4z"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.4"
      />

      {/* Ligne de barré diagonale */}
      <line
        x1="4"
        y1="20"
        x2="20"
        y2="4"
        strokeWidth="3"
        strokeLinecap="round"
        stroke="currentColor"
      />
    </svg>
  );
};

export { NoDataAvailableSVG };
